import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSession } from '@lendi/lala-react';

import { URL_PARAM_APPLICATION_ID } from '@funnels/constants/src';
import { useAuth } from '@funnels/hooks';
import { useAnalytics } from '@funnels/providers';
import { UseParams } from '@funnels/types/src';
import { datadogUtil, getViewType } from '@funnels/utils';

import { Wrapper } from './index.style';

interface AppWrapperProps {
  autoHeight?: boolean;
  transparentBackground?: boolean;
  children: React.ReactNode;
}

function AppWrapper(props: AppWrapperProps) {
  const { tracking } = useAnalytics();
  const location = useLocation();
  const { identity } = useSession();
  const userId = identity?.id;
  const userType = getViewType();
  const { [URL_PARAM_APPLICATION_ID]: applicationId } = useParams<UseParams>();

  useAuth();

  useEffect(() => {
    tracking?.page();
    window.scrollTo(0, 0);
  }, [location, tracking, userId]);

  useEffect(() => {
    datadogUtil.addContext('application', { applicationId, userType });
  }, [applicationId, userType]);

  return (
    <Wrapper autoHeight={props.autoHeight} transparentBackground={props.transparentBackground}>
      {props.children}
    </Wrapper>
  );
}

export default AppWrapper;
